import type { AddWhereClause } from '@modules/_shared/components/filters/Filters';
import type { Me } from '@modules/_shared/providers/AppDataProvider';

export const getAgentFilter = (
  me: Me,
): {
  path: string[];
  value: Parameters<AddWhereClause>[2];
} =>
  me?.is_admin || (me?.teams.length ?? 0) === 0
    ? {
        path: ['users', 'is_broker', '_eq'],
        value: true,
      }
    : {
        path: ['users', 'teams_users', 'team_id', '_in'],
        value: me?.teams.map(team => team.team_id) ?? [],
      };

export const TEAM_USER_FILTER: ReturnType<typeof getAgentFilter> = {
  path: ['users', 'teams_users'],
  value: {},
};
